import styled from 'styled-components';
import { Typography } from '../Typography';

export const Container = styled.div`
	width: 100%;
	/* max-width: 420px; */
	min-height: 40px;

	padding: 8px 8px 8px 16px;
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	flex: 1 0 0;

	border-radius: 8px;
	background-color: ${({ theme }) => theme['gray-primary']};

	h3,
	span {
		line-height: 20px;
	}
`;

export const TextContainer = styled.div`
	min-height: 40px;
	max-width: calc(100% - 50px);
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;

	svg {
		width: 24px;
		height: 24px;
	}
`;

export const Message = styled(Typography)`
	letter-spacing: 0.5px;
`;

export const Button = styled.div`
	height: 40px;
	padding: 4px;
	box-sizing: border-box;

	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;

	cursor: pointer;

	span {
		color: ${({ theme }) => theme['white-primary']};
		text-align: center;

		font-size: 14px;
		font-style: normal;
		font-weight: 700;
		line-height: 24px;
		letter-spacing: 0.5px;

		text-decoration-line: underline;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;
		text-decoration-thickness: auto;
		text-underline-offset: auto;
		text-underline-position: from-font;
	}
`;
